// Stripe appearance configuration tuned for the dark-mode brand refresh.
// Stripe Elements render in a sandboxed iframe — parent CSS cannot reach
// inside, so all theming flows through these option objects.

const tokens = require("./tokens");

// For the <Elements> provider — applies to PaymentElement and chrome.
// Legacy CardElement uses cardElementOptions (below) per-element.
const stripeElementsOptions = {
  appearance: {
    theme: "night",
    variables: {
      colorPrimary: tokens.brand[500],
      colorBackground: tokens.surface[100],
      colorText: tokens.surface[950],
      colorDanger: tokens.semantic.danger,
      fontFamily: "Inter, sans-serif",
      borderRadius: tokens.radius.md,
    },
  },
  fonts: [
    {
      cssSrc:
        "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700",
    },
  ],
};

// For legacy <CardElement> — passed via the `options` prop at the
// element use-site. Inter must be loaded on the parent page first
// (see public/index.html) so the Stripe iframe can pick it up.
const cardElementOptions = {
  style: {
    base: {
      color: tokens.surface[950],
      fontFamily: 'Inter, "Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      iconColor: tokens.brand[400],
      "::placeholder": {
        color: tokens.surface[800],
      },
    },
    invalid: {
      color: tokens.accent[400],
      iconColor: tokens.accent[400],
    },
  },
};

module.exports = { stripeElementsOptions, cardElementOptions };
module.exports.default = module.exports;
